import {
  FILL_TYPE_ANGULAR_GRADIENT,
  FILL_TYPE_IMAGE,
  FILL_TYPE_LINEAR_GRADIENT,
  FILL_TYPE_RADIAL_GRADIENT,
  SPREAD_METHOD_PAD,
  SPREAD_METHOD_REFLECT,
  SPREAD_METHOD_REPEAT,
} from './constants';
import createManagedSvgFillLibrary from './createManagedSvgFillLibrary';
import { AddBatchValues, UnsanitizedFillPropsMap, type FillType } from './types';

export {
  FILL_TYPE_ANGULAR_GRADIENT,
  FILL_TYPE_IMAGE,
  FILL_TYPE_LINEAR_GRADIENT,
  FILL_TYPE_RADIAL_GRADIENT,
  SPREAD_METHOD_PAD,
  SPREAD_METHOD_REFLECT,
  SPREAD_METHOD_REPEAT,
};

export interface SvgFillManagerInterface {
  ManagedSvgFillLibrary: React.FC<Record<string, never>>;
  getSvgFill: (a: string) => string | null;
  registerSvgFill: <TFillType extends FillType>(
    key: string,
    type: FillType,
    params: UnsanitizedFillPropsMap[TFillType]
  ) => string;
  registerSvgFills: (values: AddBatchValues) => { [key: string]: string };
  unregisterSvgFill: (key: string | string[]) => void;
}

let instance: SvgFillManagerInterface | null = null;

// NOTE: Order of arguments is transposed from internal registerSvgFill
export function registerSvgFill<TFillType extends FillType>(
  type: TFillType,
  params: UnsanitizedFillPropsMap[TFillType],
  key: string
) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { registerSvgFill: _registerSvgFill } = getInstance();
  return _registerSvgFill(key, type, params);
}

/**
 * Returns the SvgFillManager interface singleton (creating it if necessary)
 *
 * @return {SvgFillManager} singleton instance
 */
export default function getInstance(): SvgFillManagerInterface {
  if (!instance) {
    instance = createManagedSvgFillLibrary();
  }
  return instance;
}
